import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {Button} from "../../components/buttons";
import {Card, Col, Container, Row} from "react-bootstrap";
import {ItemsAccordion} from "../../components/ItemsAccordion";
import {useGetPatientProfileAppointments} from "../../actions/patientProfileActions";
import {Timeline} from "../../components/Timeline";
import {EQHSpinner} from "../../components/EQHSpinner";
import {appointmentsReducer} from "../../reducers/patientProfile/appointmentsReducer";
import CalendarViewModal from "../appointment/CalenderViewModal";
import {
    formatDate,
    formatDuration,
    formatLocalDate,
    formatStringProper,
    formatTimeOnly,
    getWrittenDate,
} from "../../utils/util";
import Modals from "../../components/modals";
import {getFileDownload} from "../../actions/fileUploadActions";
import {useDispatch} from "react-redux";
import axios from "../../utils/apiClient";
import {useAuth} from "../../context/authContext";
import {QuickListContext} from "../quickList/QuickListContext";
import {useGetTransQuickListSettings} from "../quickList/quickListSettings";

const componentName = "patientProfile-Appointment";

const baseURL = `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile`;

const AppointmentCard = ({ appointment, updateList, patient, carePaths, idx }) => {
  const dispatch = useDispatch();
  const auth = useAuth();

  const [showEditAppointmentModal, setShowEditAppointmentModal] = useState(
    false
  );

  const handleClickofLink = (file) => {
    if (file?.metadata?.fileId) {
      dispatch(
        getFileDownload(file?.metadata?.fileId, file?.metadata?.fileName)
      );
    }
  };
  return (
    <Container fluid>
      <Modals
        show={showEditAppointmentModal}
        onHide={() => setShowEditAppointmentModal(false)}
        title={`Edit Appointment: ${patient.lastName}, ${patient.firstName}`}
        titleid={`${componentName}-editAppointment`}
        size="xl"
        completeBtn={"Save"}
        completeBtnId={`${componentName}-saveButton`}
        hideFooter={true}
        body={
          <CalendarViewModal
            parent="CPCard"
            onHideClicked={() => setShowEditAppointmentModal(false)}
            updateParentAppointment={updateList}
            selectedPatient={appointment}
            removeAppointment={updateList}
            patientSpecific={patient}
            patientCarePaths={carePaths}
          />
        }
      />
      <Row className="mb-2">
        <Col id={`${componentName}-appointmentName-${idx}`} sm={3}>
          <span id={`${componentName}-appointmentNameLabel-${idx}`} className="fw-bold d-block">Appointment Name</span>
          <span id={`${componentName}-appointmentNameValue-${idx}`}>{appointment.name}</span>
        </Col>
        <Col id={`${componentName}-appointmentDate-${idx}`} sm={3}>
          <span id={`${componentName}-appointmentDateLabel-${idx}`} className="fw-bold d-block">
            {getWrittenDate(appointment.appointmentDateTime)}
          </span>
          <span id={`${componentName}-appointmentDateValue-${idx}`}>{formatDuration(
            appointment.appointmentDateTime,
            appointment.durationInMinutes
          )}</span>
        </Col>
        <Col id={`${componentName}-appointmentStatus-${idx}`} sm={3}>
          <span id={`${componentName}-appointmentStatusLabel-${idx}`} className="fw-bold d-block">Status</span>
          <span id={`${componentName}-appointmentStatusValue-${idx}`}>{appointment.cancelled === true
            ? "Cancelled"
            : formatStringProper(appointment.status)}</span>
        </Col>
        {appointment.cancelled ? null : (
          <Col id={`${componentName}-appointmentEdit-${idx}`} sm={2} className="text-end me-4">
            {auth.hasAuthority("AUTH_APPOINTMENTS_WRITE_ACCESS") && (
              <Button
                variant="secondary"
                id={`${componentName}-appointmentEditButton-${idx}`}
                className="align-end"
                onClick={() => setShowEditAppointmentModal(true)}
              >
                Edit Appointment
              </Button>
            )}
          </Col>
        )}
      </Row>
      <Row className="mb-2">
        <Col id={`${componentName}-appointmentProvider-${idx}`} sm={3}>
          <span id={`${componentName}-appointmentProviderLabel-${idx}`} className="fw-bold d-block">Provider</span>
          <span id={`${componentName}-appointmentProviderName-${idx}`}>{appointment.provider.lastName == null ? '' : appointment.provider.lastName +", "+ appointment.provider.firstName}</span>
          <br />
          <span id={`${componentName}-appointmentProviderAddress-${idx}`}>{appointment.address}</span>
        </Col>
        <Col id={`${componentName}-appointmentReminder-${idx}`} sm={3}>
          <div className="d-flex justify-content-start gap-2">
            <input
              type="checkbox"
              id={`${componentName}-appointmentReminderCheck-${idx}`}
              checked={appointment.shouldSendReminder}
              disabled={true}
            />
            <span id={`${componentName}-appointmentreminderLabel-${idx}`}>Patient Reminder ({appointment.notificationDelay}{" "}
            {formatStringProper(appointment.notificationDelayUnit)} Delay)</span>
          </div>
        </Col>
        <Col id={`${componentName}-appointmentNeeds-${idx}`} sm={3}>
          <div className="d-flex justify-content-start gap-2">
            <input
              type="checkbox"
              id={`${componentName}-appointmentNeedsCheck-${idx}`}
              checked={appointment.needsTransportation}
              disabled={true}
            />
            <span id={`${componentName}-appointmentNeedsLabel-${idx}`}>Patient Needs Transportation</span>
          </div>
        </Col>
        <Col id={`${componentName}-appointmentCarePath-${idx}`} sm={3}>
          <span id={`${componentName}-appointmentCarePathLabel-${idx}`} className="fw-bold d-block">Care Program</span>
          <span id={`${componentName}-appointmentCarePathValue-${idx}`}>{appointment.carePathName == null ? "-" : appointment.carePathName}</span>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col id={`${componentName}-appointmentAttachments-${idx}`} sm={3}>
          <span id={`${componentName}-appointmentAttachmentsLabel-${idx}`} className="fw-bold d-block">Attachments</span>
          {appointment?.files &&
            appointment?.files.length > 0 &&
            appointment?.files.map((file) => (
              <span id={`${componentName}-appointmentAttachmentsValue-${idx}`} className="d-block" key={file?.metadata?.fileId}>
                {file && (
                  <small>
                    <button
                      type="button"
                      id={`${componentName}-appointmentAttachmentsLink-${idx}`}
                      className="btn btn-link p-0 align-baseline"
                      onClick={() => handleClickofLink(file)}
                    >
                      {file?.metadata?.fileName}
                    </button>
                  </small>
                )}
                {"  "}
              </span>
            ))}
        </Col>
        <Col id={`${componentName}-appointmentNotes-${idx}`} sm={9}>
          <span id={`${componentName}-appointmentNotesLabel-${idx}`} className="fw-bold d-block">Notes</span>
          <span id={`${componentName}-appointmentNotesValue-${idx}`}>{appointment.note}</span>
        </Col>
      </Row>
    </Container>
  );
};

AppointmentCard.propTypes = {
  appointment: PropTypes.shape({
    name: PropTypes.string,
    appointmentDateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    durationInMinutes: PropTypes.number,
    cancelled: PropTypes.bool,
    status: PropTypes.string,
    provider: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    address: PropTypes.string,
    shouldSendReminder: PropTypes.bool,
    notificationDelay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    notificationDelayUnit: PropTypes.string,
    needsTransportation: PropTypes.bool,
    carePathName: PropTypes.string,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        metadata: PropTypes.shape({
          fileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          fileName: PropTypes.string,
        }),
      })
    ),
    note: PropTypes.string,
    lastModified: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  updateList: PropTypes.func.isRequired,
  patient: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  carePaths: PropTypes.array,
  idx: PropTypes.number,
};

const ALL = "All";
const UPCOMING = "Upcoming";
const PAST = "Past";

const renderAppointmentTimelineTitle = (item, idx) => (
  item?.lastModified ? (
    <span>
      <span id={`${componentName}-tlDate-${idx}`} className="d-block fw-bold">
        {formatLocalDate(item.lastModified)}
      </span>
      <span id={`${componentName}-tlTime-${idx}`}>
        {formatTimeOnly(item.lastModified)}
      </span>
    </span>
  ) : (
    "-"
  )
);

const renderAppointmentTimelineBody = (context, item, idx) => (
  <AppointmentCard
    appointment={item}
    idx={idx}
    updateList={context.updateList}
    patient={context.patient}
    carePaths={context.carePaths}
  />
);

const renderAppointmentsAccordionBody = (context, key, list) => (
  <Timeline
    items={list}
    titleBuilder={renderAppointmentTimelineTitle}
    bodyBuilder={renderAppointmentTimelineBody.bind(null, context)}
  />
);

const Appointments = ({ patient, selectedTab, reloadPatientOverview, idx }) => {
  const auth = useAuth();
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [carePaths, setCarePaths] = useState([]);
  const appointmentsPkg = useGetPatientProfileAppointments(
    [],
    appointmentsReducer
  );

  const getSettingsRef = useGetTransQuickListSettings(
    "preventiveCare",
    0,
    auth
  );

  const patientId = patient?.id;
  const hasValidPatientId =
    patientId !== undefined &&
    patientId !== null &&
    `${patientId}`.trim() !== "" &&
    `${patientId}` !== "undefined";

  useEffect(() => {
    if (selectedTab && hasValidPatientId) {
      appointmentsPkg.fetchData(patientId);
      getCarePaths();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId, selectedTab]);

  const headerAndSelectorMap = {
    [ALL]: (item) => true,
    [UPCOMING]: (item) => {
      let todayTime = Date.now();
      let appointmentTime = new Date(item.appointmentDateTime).getTime();

      if (appointmentTime >= todayTime && item.cancelled === false) {
        return item;
      }
    },
    [PAST]: (item) => {
      let today = formatDate(new Date());
      let todayTime = new Date(today).getTime();
      let appointmentTime = new Date(item.appointmentDateTime).getTime();

      if (appointmentTime <= todayTime || item.cancelled === true) {
        return item;
      }
    },
  };

  const getCarePaths = () => {
    if (!hasValidPatientId) {
      return;
    }

    axios
      .get(baseURL + `/care-paths?patientId=${patientId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setCarePaths(res.data);
      })
      .catch((err) => {
      });
  };

  const updateAppointmentsAndOverview = () => {
    if (hasValidPatientId) {
      appointmentsPkg.fetchData(patientId);
    }
    reloadPatientOverview();
  };

  const appointmentsRenderContext = {
    updateList: updateAppointmentsAndOverview,
    patient,
    carePaths,
  };

  return (
    <Container fluid>
      <QuickListContext.Provider value={getSettingsRef()}>
          <Modals
            show={showAppointmentModal}
            onHide={() => setShowAppointmentModal(false)}
            title="Appointment"
            titleid={`${componentName}-AppointmentModal`}
            size="xl"
            completeBtn={"Confirm"}
            completeBtnId={`${componentName}-confirmButton`}
            hideFooter={true}
            body={
              <CalendarViewModal
                parent="CPCard"
                onHideClicked={() => setShowAppointmentModal(false)}
                updateParentAppointment={() => {
                  if (hasValidPatientId) {
                    appointmentsPkg.fetchData(patientId);
                  }
                  reloadPatientOverview();
                }}
                selectedPatient={null}
                removeAppointment={() => {
                  if (hasValidPatientId) {
                    appointmentsPkg.fetchData(patientId);
                  }
                }}
                patientSpecific={patient}
                patientCarePaths={carePaths}
              />
            }
          />
          {appointmentsPkg.state.isLoading && <EQHSpinner />}
          {appointmentsPkg.state.error ? (
            <Card>
              <Card.Body id={`${componentName}-appointmentsError-${idx}`}>{appointmentsPkg.state.error}</Card.Body>
            </Card>
          ) : (
            <Card>
              <Card.Body>
                <Row className="mb-2">
                  <Col>
                    {auth.hasAuthority("AUTH_APPOINTMENTS_WRITE_ACCESS") && (
                      <Button
                        variant="primary"
                        id={`${componentName}-addAppointmentButton`}
                        onClick={() => setShowAppointmentModal(true)}
                      >
                        + Appointment
                      </Button>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ItemsAccordion
                      items={appointmentsPkg.state.data}
                      headerAndSelectorMap={headerAndSelectorMap}
                      selected={"All"}
                      bodyBuilder={renderAppointmentsAccordionBody.bind(
                        null,
                        appointmentsRenderContext
                      )}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
      </QuickListContext.Provider>
    </Container>
  );
};

Appointments.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  selectedTab: PropTypes.bool,
  reloadPatientOverview: PropTypes.func.isRequired,
  idx: PropTypes.number,
};

export { Appointments };
